<script lang="ts" generics="T">
	import { type SelectOption } from './selectOption'
	import { _ } from '@repo/i18n'
	import { type ChangeEventHandler } from 'svelte/elements'

	interface Props {
		options: SelectOption<T>[]
		values?: T[]
		name: string
		required?: boolean
		disabled?: boolean
		multiple?: boolean
		onChange: ChangeEventHandler<HTMLSelectElement>
	}

	let {
		options,
		values: rawValues = [],
		name,
		required = false,
		disabled = false,
		multiple = false,
		onChange,
	}: Props = $props()

	let key = $derived(options?.length > 0 ? options[0].key : null)
	let values = $derived.by(() => {
		if (multiple) {
			return rawValues ? rawValues.map((v) => (key ? key(v) : JSON.stringify(v))) : []
		}

		const rawValue = rawValues?.length > 0 ? rawValues[0] : null
		return rawValue ? (key ? key(rawValue) : JSON.stringify(rawValue)) : null
	})
</script>

<select
	{name}
	class="pointer-events-none absolute top-0 right-0 bottom-0 left-0 opacity-0"
	{disabled}
	{multiple}
	{required}
	tabindex="-1"
	onchange={onChange}
	value={values}
>
	<option value="">
		{$_('form.select.empty')}
	</option>
	{#each options as option}
		<option value={option.key ? option.key(option.value) : JSON.stringify(option.value)}>
			{option.label}
		</option>
	{/each}
</select>
